import { createContext } from 'react';
import type { ConfirmOptions, PromptOptions } from './ConfirmDialog';

export interface ConfirmCtx {
  confirm: (opts: ConfirmOptions) => Promise<boolean>;
  /** Not/neden gibi kısa metin toplayan modal. İptalde null, onayda trim'lenmiş değer döner. */
  prompt: (opts: PromptOptions) => Promise<string | null>;
}

export const ConfirmContext = createContext<ConfirmCtx | null>(null);
